<template>
    <div class = 'col-md-12'>
        <div class = 'row'>
            <div class = 'col-md-12 mb-1'>
                <p>We are <a href='https://ecl.mat.ucsb.edu'>researchers and educators</a> who are interested in understanding and exploring relationships between art and craft production, technology, and business. We are focused on computational fabrication: the combination of computational design and digital fabrication. In computational fabrication, a form is designed by writing a computer program and then constructed, at least partially, via fabrication machines like 3D printers. New design technologies like <a href="https://3dpotter.com/">clay 3D printers</a> have emerged that support the use of traditional craft materials in computational fabrication.</p>

                <p>Our goal is to co-develop new technologies and new ceramic work in collaboration with ceramic artists and to to support small and rural craft-based businesses in Central and Southern California.  In the process we aim to explore methods to integrate computational fabrication with ceramics craft while also understanding how digital technologies may limit important values, aesthetics, or traditions in ceramics production.</p>
            </div>
        </div>
        <div class = 'row'>
            <div class = 'col-md-12 mb-1'>
                <h2>Project</h2>
                <h4>Interviews with Ceramics Practitioners</h4>
                <p>We are conducting interviews with professional ceramic practitioners in Central and Southern California and New Mexico. These interviews help us to understand the variety of ways ceramic artists work, use technology, and what the core values of their practices are.</p>
                <p><b>If you are a California-based ceramic artist and are interested in participating in this project, we would love to hear from you! Contact us at <a href="mailto:jmjacobs@ucsb.edu?subject=Ceramics Interviews">jmjacobs@ucsb.edu</a></b></p>

                <h4>Educational Outreach</h4>
                <p>In partnership with the <a href="https://csep.cnsi.ucsb.edu/programs/k12">Center for Science and Engineering Partnerships</a> at UCSB, we are teaching computational craft workshops for high school and middle school students to introduce students to the opportunities of applying programming for art and physical making.</p>

                <h4>Collaborative Ceramics Residencies</h4>
                <p>We are hosting a series of funded artist residencies in which artists will collaborate with Expressive Computation researchers to create new ceramic work and new technology to support ceramics practice. As a part of these residencies, we are organizing exhibitions, to take place at UCSB and in venues around the state, to showcase the work developed in our residencies.</p>

                <h4>Development Workshops</h4>
                <p>We are hosting a series of conferences to support small and rural craft-based businesses in California. Funding is available to cover travel and housing costs for participants.</p>
            </div>
        </div>
        <div class = 'row'>
            <div class = 'col-md-12 mb-1'>
                <h2>Who We Are</h2>
                <p>This project is a collaborative effort by researchers at the University of California, Santa Barbara and the University of New Mexico. The research in California is overseen by <a href="https://jenniferjacobs.mat.ucsb.edu">Jennifer Jacobs</a>, Assistant Professor of <a href="https://mat.ucsb.edu">Media Arts and Technology</a> and Director of the <a href="https://ecl.mat.ucsb.edu">Expressive Computation Lab</a> at <a href="https://ucsb.edu">The University of California, Santa Barbara</a></p>

                <p>The research in New Mexico is overseen by <a href="https://handandmachine.org/index.php/2019/12/04/leah-buechley/">Leah Buechley</a>, Associate Professor of Computer Science and Director of the <a href="https://handandmachine.org/">Hand and Machine Lab</a> at <a href="https://www.unm.edu/">The University of New Mexico</a>.  We are also collaborating with <a href="https://www.mgt.unm.edu/faculty/facultyDetails.asp?id=10320">Manuel Montoya</a> from the Anderson School of Management, and <a href="https://saap.unm.edu/people/faculty/tim-b-castillo/index.html">Tim Castillo</a> and <a href="https://idpi.unm.edu/about/people/theodore-jojola.html">Ted Jojola</a> from Architecture and Planning at The University of New Mexico.</p>
            </div>
        </div>
        <div class = 'row'>
            <div class = 'col-md-12 mb-1'>
               <p>This research is supported by the National Science Foundation. Award number: <a href="https://www.nsf.gov/awardsearch/showAward?AWD_ID=2026286&HistoricalAwards=false">2026286</a></p>
            </div>
        </div>
    </div>
</template>

<script>
import NewsService from '@/services/NewsService'
import SlideshowService from '@/services/SlideshowService'

export default {
  name: 'home',

  components: {
  },

  data () {
    return {
      airtableResponse: [],
      slideshowResponse: []
    }
  },

  mounted: function () {
    const self = this
    async function getNews () {
      try {
        const response = await NewsService.getNews()
        self.airtableResponse = response.data.records
        console.log(self.airtableResponse)
      } catch (err) {
        console.log(err)
      }
    }

    async function getSlideshow () {
      try {
        const response = await SlideshowService.getSlideshow()
        self.slideshowResponse = response.data.records
      } catch (err) {
        console.log(err)
      }
    }
    getNews()
    getSlideshow()
  },

  methods: {
    shuffle: function (array) {
      var currentIndex = array.length; var temporaryValue; var randomIndex

      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1

        // And swap it with the current element.
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
      }

      return array
    }

  },

  computed: {
    slideshow () {
      const self = this
      const imageList = []
      for (var i = 0; i < self.slideshowResponse.length; i++) {
        if (self.slideshowResponse[i].fields.published) {
          const imageItem = {
            description: self.slideshowResponse[i].fields.description,
            alttext: self.slideshowResponse[i].fields.alttext,
            image: self.slideshowResponse[i].fields.image[0].url
          }
          imageList.push(imageItem)
        }
      }
      console.log(imageList)
      self.shuffle(imageList)
      return imageList
    },
    news () {
      const self = this
      const newsList = []
      for (var i = 0; i < self.airtableResponse.length; i++) {
        if (self.airtableResponse[i].fields.published) {
          const newsItem = {
            title: self.airtableResponse[i].fields.title,
            text: self.airtableResponse[i].fields.text,
            date: new Date(self.airtableResponse[i].fields.date)
          }
          newsList.push(newsItem)
        }
      }
      newsList.sort(function (a, b) {
        if (a.date > b.date) {
          return -1
        } else {
          return 1
        }
      })

      return newsList
    }
  }
}
</script>
